
import { Organization } from '@/models/Organization';
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  components: {
      
  }
})
export default class RideitPassengers extends Vue {

  pagination = {
    rowsPerPage: 10 // -1 for All,
  }

  organization: Organization = this.getOrganization();
  
  getOrganization() {
    const organizationId = this.$route.params.organizationId;
    return this.$store.state.organization.organizations.find((o: Organization) => o.id === organizationId);
  }

}
